import { useEffect, useState } from 'react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

const Account = () => {
    const [name, setName] = useState('Username')
    const [pharmacyName, setPharmacyName] = useState('Pharma name')
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        let mounted = true
        const fetchAccount = async () => {
            try {
                const res = await fetch('/api/account')
                if (!res.ok) throw new Error('Failed to load')
                const data = await res.json()
                if (!mounted) return

                setName(data.name || 'Username')
                setPharmacyName(data.pharmacyName || 'Pharma name')
            } catch (err) {
                console.error('Unable to load account', err)

            } finally {
                if (mounted) setLoading(false)
            }
        }
        fetchAccount()
        return () => {
            mounted = false
        }
    }, [])

    const onSubmit = (e: React.FormEvent) => {
        e.preventDefault()
        // fetch('/api/account', { method: 'PUT', body: JSON.stringify({ name, pharmacyName }) })
        console.log({ name, pharmacyName })
    }

    return (
        <>
            <div>
                <h2 className="text-2xl font-bold tracking-tight">Accounts</h2>
                <p className="text-muted-foreground">Manage your accounts details.</p>
            </div>

            <hr className="my-4" />

            <form onSubmit={onSubmit} className="flex flex-col gap-y-8">
                <div>
                    <Label htmlFor="name" className="text-gray-700">
                        Name
                    </Label>
                    <Input
                        id="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className="max-w-[300px] mt-2 h-8"
                        placeholder="Your name"
                        disabled={loading}
                    />
                    <Label className="text-gray-500 text-xs">
                        This is the name that will be displayed on your receipts after checkout.
                    </Label>
                </div>

                <div>
                    <Label htmlFor="pharmacyName" className="text-gray-700">
                        Pharmacy Name
                    </Label>
                    <Input
                        id="pharmacyName"
                        value={pharmacyName}
                        onChange={(e) => setPharmacyName(e.target.value)}
                        className="max-w-[300px] mt-2 h-8"
                        placeholder="Pharmacy name"
                        disabled={loading}
                    />
                    <Label className="text-gray-500 text-xs">
                        This is the name that will be displayed on your receipts after checkout.
                    </Label>
                </div>

                <Button className="max-w-[300px]" type="submit" disabled={loading}>
                    {loading ? 'Loading…' : 'Update Account'}
                </Button>
            </form>
        </>
    )
}

export default Account